import React from "react";
import CloneRepo from "../CodeOverview/CloneRepo.jsx";

function CodeImpactAnalysis() {


  return (
    <>
      <CloneRepo />
    </>
  );
}

export default CodeImpactAnalysis;